// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ToolsMenu-cls1___fbebe641d5365b5e90f{/*!*/}.ToolsMenu-cls2__a5b8862487083335c5f3{margin-right:12px;height:20px;width:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ToolsMenu-cls1___fbebe641d5365b5e90f",
	"cls2": "ToolsMenu-cls2__a5b8862487083335c5f3 ToolsMenu-cls1___fbebe641d5365b5e90f"
};
export default ___CSS_LOADER_EXPORT___;
